import { GradientType } from '@ui/types'
import { colors } from '@ui/colors'
import { UiVariant } from '@ui/theme/variants'
import { hex } from '@ui/utils/hex'

export type HighlightVariant = Exclude<UiVariant, 'neutral' | 'warning'>

export const colorBackground: Record<HighlightVariant, GradientType> = {
  disabled: [colors.white, colors.white],
  default: [colors.gray[50], colors.gray[50], colors.white25, colors.white],
  active: [colors.blue10, colors.white25, colors.white75],
  success: [colors.green5, colors.white0, colors.white75],
  danger: [colors.red5, colors.white0, colors.white75],
  attention: [colors.orange10, colors.white0, colors.white75],
}

export const colorPressed: Record<HighlightVariant, GradientType> = {
  disabled: [colors.white, colors.white],
  default: [colors.text10, colors.text5, colors.white0, colors.white0],
  active: [colors.blue[100], colors.blue[100], colors.white25, colors.white75],
  success: [colors.green10, colors.green5, colors.white0, colors.white75],
  danger: [colors.red10, colors.red5, colors.white0, colors.white75],
  attention: [colors.orange10, colors.orange5, colors.white0, colors.white75],
}

export const colorBorder: Record<HighlightVariant, string> = {
  disabled: colors.black10,
  default: colors.black10,
  active: colors.blue[500],
  success: hex(colors.green[600], 0.5),
  danger: hex(colors.red[600], 0.5),
  attention: hex(colors.orange[500], 0.5),
}
